import React, { useState, useEffect } from 'react'

import { PageLink } from 'src/components/link'
import { useCartTotals, useCartItems, useCheckout, useToggleCart } from 'src/context/siteContext'

import {
  LineItem
} from 'src/components/cart/lineItem'

export const Cart = () => {
  const lineItems = useCartItems()
  const openCheckout = useCheckout()
  const toggleCart = useToggleCart()
  const { total } = useCartTotals()
  return (
    <div className='cart__main'>
      {lineItems.length > 0 ? (
        <div className='bcb cw p1'>
          {lineItems.map((item: { id: string, quantity: number }) => (
            <React.Fragment key={item.id + item.quantity}>
              <LineItem {...item} />
            </React.Fragment>
          ))}
        </div>
      ) : (
        <div className='ac'>
        </div>
      )}
      <div className='bcb cw ac p1'>
        <div className='x jcb '>
          {lineItems.length > 0 && (
            <div className='x f jcb aic mb1 pb1 cart__subtotal'>
              <span className='s1 caps'>Subtotal</span>
              <span className='s1 caps'>{total}</span>
            </div>
          )}
        </div>
        {lineItems.length < 1 ? (
          <div className='f jcc aic rel x'>
            <PageLink className='s1 caps m05'  onClick={() => toggleCart()} to='/'>empty</PageLink>
          </div>
        ): (
          <button onClick={() => openCheckout()} type='submit' className='ml05 x px05 s1 button--border cw caps s20 button'>
            <span className=''>Checkout</span>
          </button>
        )}
      </div>
    </div>
  )
}